'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isEmpty = require('lodash/isEmpty');

var ValidationSuccess = require('./models/validation-success');
var ValidationFailure = require('./models/validation-failure');

module.exports = function (response) {
  if (!response) return false;

  var valProp = response.values ? 'values' : 'value';
  var writeInProp = response.writeIns ? 'writeIns' : 'writeIn';

  var errorMessages = [];

  //If both non disclosure and none were chosen, the response is invalid
  if (response.nonDisclosure && response.none) {
    errorMessages = [].concat(_toConsumableArray(errorMessages), ['The "None" and "Prefer not to disclose" options may not both be selected']);
  }

  //If there is both a selected value and a write in, the response is invalid
  if (response.value && response.writeIn) {
    errorMessages = [].concat(_toConsumableArray(errorMessages), ['You may not select both a supplied option and provide a written in response']);
  }

  var hasValueOrWriteIn = function hasValueOrWriteIn(res) {
    return !isEmpty(res[valProp]) || !isEmpty(res[writeInProp]);
  };

  //If the non disclosure or none option was chosen, no values should exist
  if ((response.nonDisclosure || response.none) && hasValueOrWriteIn(response)) {
    errorMessages = [].concat(_toConsumableArray(errorMessages), ['You may not both select a valid option and select a non-answer option']);
  }

  //If nothing was chosen, the response is invalid
  if (!response.nonDisclosure && !response.none && !hasValueOrWriteIn(response)) {
    errorMessages = [].concat(_toConsumableArray(errorMessages), ['You must select an option']);
  }

  return errorMessages.length ? new ValidationFailure(errorMessages) : new ValidationSuccess();
};